import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Stack, Text, Button, Center, Paper } from '@mantine/core';
import { IconCircleCheck } from '@tabler/icons-react';
import { setCurrentPage } from '../redux/app.slice';
import { stripeApi } from '../apis/stripe.api';

const SubscriptionUpdateSuccess = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    dispatch(setCurrentPage('subscription-update-success'));
    
    const handleSubscription = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const sessionId = searchParams.get('session_id');
      
      if (!sessionId) {
        console.error('No session ID found in URL');
        setError('Invalid session');
        setLoading(false);
        return;
      }

      try {
        const response = await stripeApi.handleSubscriptionSuccess(sessionId);
        console.log('*** Subscription update success response:', response);
        setLoading(false);
      } catch (error) {
        console.error('Subscription update processing failed:', error);
        setError(error.message || 'Failed to process subscription update');
        setLoading(false);
      }
    };

    handleSubscription();
  }, [dispatch]);

  if (loading) {
    return (
      <Center style={{ height: '100vh' }}>
        <Paper p="xl" shadow="sm" radius="md">
          <Stack align="center" spacing="md">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
            <Text size="xl" weight={500} align="center">
              Processing Your Update
            </Text>
            <Text color="dimmed" size="sm" align="center">
              Please wait while we confirm your changes...
            </Text>
          </Stack>
        </Paper>
      </Center>
    );
  }

  if (error) {
    return (
      <Center style={{ height: '100vh' }}>
        <Paper p="xl" shadow="sm" radius="md">
          <Stack align="center" spacing="md">
            <Text size="xl" weight={500} align="center" color="red">
              Update Error
            </Text>
            <Text color="dimmed" size="sm" align="center">
              {error}
            </Text>
            <Button onClick={() => window.close()}>
              Close Window
            </Button>
          </Stack>
        </Paper>
      </Center>
    );
  }

  return (
    <Center style={{ height: '100vh' }}>
      <Paper p="xl" shadow="sm" radius="md">
        <Stack align="center" spacing="md">
          <IconCircleCheck size={48} color="green" />
          <Text size="xl" weight={500} align="center">
            Your payment has been received
          </Text>
          <Text color="dimmed" size="sm" align="center">
            Please close this window to continue
          </Text>
          <Button onClick={() => window.close()}>
            Close Window
          </Button>
        </Stack>
      </Paper>
    </Center>
  );
};

export default SubscriptionUpdateSuccess;